var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"message",staticClass:"h-center v-center animate fadedout video-caption"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.videoMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }